import { FerryIngredient } from '@apps/main/modules/recipe/ingredients';
import type { FerryIngredientFilters } from '@apps/main/modules/recipe/ingredients/ferryIngredient';

import { TransportVehicleType } from '@libs/trip-planner-interfaces';

import { safelyDeserializeFilter } from '../helpers';
import {
  deserializeAvailabilityOrder,
  deserializeIngredientParameters,
  deserializePorts,
  deserializeTransportFilters,
} from '../deserializeTransport';

import { FERRY_INGREDIENT_SUFFIX } from './constants';

export function deserializeFerry(value: string): FerryIngredient {
  const ferry = new FerryIngredient();
  ferry.isConfirmed = true;
  const serializedFerry = value.slice(0, -FERRY_INGREDIENT_SUFFIX.length);

  const {
    serializedPorts,
    transportIds,
    serializedProps,
    serializedAvailabilityOrder,
  } = deserializeIngredientParameters(serializedFerry);

  const { fromPort, toPort } = deserializePorts(serializedPorts);

  ferry.fromPort = fromPort;
  ferry.toPort = toPort;

  ferry.transportIds = transportIds;

  const { filters, vehicles } = deserializeFerryProps(serializedProps);

  ferry.filters = filters;

  ferry.vehicles = vehicles;

  ferry.availabilityOrder = deserializeAvailabilityOrder(
    serializedAvailabilityOrder
  );

  return ferry;
}

export function deserializeFerryProps(serializedProps: string[]): {
  filters: FerryIngredientFilters;
  vehicles: TransportVehicleType[];
} {
  const transportFilters = deserializeTransportFilters(serializedProps);

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  const serializedFerryVehicles = serializedProps.slice(5);
  const vehicles = deserializeFerryVehicles(serializedFerryVehicles);

  return {
    filters: transportFilters,
    vehicles,
  };
}

export function deserializeFerryVehicles(
  serializedFerryVehicles: string[]
): TransportVehicleType[] {
  const deserializedVehicles = serializedFerryVehicles.map(
    (vehicle) =>
      safelyDeserializeFilter(
        vehicle,
        (value) => value as TransportVehicleType
      ) ?? TransportVehicleType.None
  );

  return deserializedVehicles.length === 0
    ? [TransportVehicleType.None]
    : deserializedVehicles;
}
